export const IMAGE_FROM_BANK = "AnswerVariantImageBankDto";
